import { createRouter, createWebHashHistory } from 'vue-router'
import Landing from '@/story/landing';
import store from '@/store/';

const routes = [
	{
		path: '',
		name: 'landing',
		component: Landing
	},
	{
		path: '/keuze',
		name: 'standpunt',
		component: () => import(/* webpackChunkName: "about" */ '@/story/keuze.vue')
	},

	{
		path: '/opties',
		name: 'opties',
		component: () => import('@/story/keuze-gasten.vue')
	},
		{
		path: '/thermometer',
		name: 'thermometer',
		component: () => import('@/story/thermometer.vue')
	},
		{
		path: '/tafel',
		name: 'tafel',
		component: () => import('@/story/tafel.vue')
	},
		{
		path: '/einde',
		name: 'eindscherm',
		component: () => import('@/story/eindscherm.vue')
	},

	{ path: '/:pathMatch(.*)*', 
		name: 'landing', 
		component: Landing 
	}
]

const router = createRouter({
	history: createWebHashHistory(),
	routes,
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}	
});

let first = true;


router.beforeEach((to, from, next) => {
	if(to.query.s && to.query.g) {
		store.dispatch('updateStandpunt', {state: +to.query.s});
		store.dispatch('updateNaam', to.query.n);

		let gasten = new Buffer(to.query.g, 'base64').toString('ascii');
		let gastenArr = gasten.split(',');

		gastenArr.forEach(num => {
			let gast = store.getters.getGuestById(+num);
			if (!gast) return;

			store.dispatch('updateGuests', gast);						
		});

		next();
	} else if (first) {
		first = false;
		next({
			name: "landing"
		});


	}

	next();

});


export default router
